import { render, staticRenderFns } from "./CopyFormDialog.vue?vue&type=template&id=2541b1b2&scoped=true"
import script from "./CopyFormDialog.vue?vue&type=script&lang=js"
export * from "./CopyFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2541b1b2",
  null
  
)

export default component.exports